<template>
  <div>
    <VueApexCharts type="bar" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  // mixins: [Mixin],
  props: {
    lista: { required: true, type: Object },
  },
  components: {
    VueApexCharts,
  },
  data: () => ({
    series: [
      {
        name: "Atendimentos",
        data: [],
      },
    ],
    chartOptions: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
          tools: {
            download: true,
          },
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
      },
    },
  }),
  beforeMount() {
    this.series[0].data = this.lista.atendimentos;
    this.chartOptions.xaxis.categories = this.lista.descricao;
  },
};
</script>
